import{m as r}from"./chunk-HBP5N4FR.js";r();function p({transactions:e}){return e==null?void 0:e.some(i=>Array.isArray(i))}export{p as a};
//# sourceMappingURL=chunk-VW2UBFJI.js.map
